<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proyectos</li>
                <li class="breadcrumb-item active" aria-current="page">Catálogo de certificaciones</li>
            </ol>
        </nav>
        
        <div class="container-fluid">
			<vx-card class="mb-5">
				<h1 class="bold big-title m-0">Catálogo de <span>certificaciones</span>.</h1>
			</vx-card>
            <vx-card title="Lista de entidades certificadoras registradas" class="mb-5">
				<vs-table :data="certifyingEntitiesList" ref="certifyingEntitiesTable" stripe search noDataText="No se han generado registros" pagination :max-items="certifyingEntitiesPerPage">
					<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                            <vs-button color="primary" type="border" icon-pack="feather" @click="openCreateModal('certifyingEntity')">Agregar entidad certificadora</vs-button>
                        </div>

						<vs-dropdown v-if="isMounted" vs-trigger-click class="cursor-pointer mr-4 items-per-page-handler">
							<div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              					<span class="mr-2">{{ currentCertifyingEntitiesPage * certifyingEntitiesPerPage - (certifyingEntitiesPerPage - 1) }} - {{ certifyingEntitiesList.length - currentCertifyingEntitiesPage * certifyingEntitiesPerPage > 0 ? currentCertifyingEntitiesPage * certifyingEntitiesPerPage : certifyingEntitiesList.length }} de {{ queriedCertifyingEntitiesItems }}</span>
              					<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            				</div>
            				<vs-dropdown-menu>
              					<vs-dropdown-item v-for="it in itemsPerPageDefinitions" @click="certifyingEntitiesPerPage = it" :key="it">
                					<span>{{it}}</span>
              					</vs-dropdown-item>
            				</vs-dropdown-menu>	
						</vs-dropdown>
					</div>

					<template slot="thead">
						<vs-th class="bold" sort-key="name">NOMBRE</vs-th>
						<vs-th class="bold">ACCIONES</vs-th>
					</template>

					<template slot-scope="{data}">
						<vs-tr :key="index" v-for="(tableRow, index) in data">
							<vs-td :data="data[index].name">
								{{ data[index].name }}
							</vs-td>

							<vs-td :data="data[index].id">
								<feather-icon icon="EyeIcon" class="ml-3" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" @click.stop="openEditModal('certifyingEntity', data[index])" />
								<feather-icon icon="TrashIcon" class="ml-3" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" @click.stop="handleOnDelete('certifyingEntity', data[index])" />
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vx-card>

            <vx-card title="Lista de certificaciones registradas" class="mb-5">
				<vs-table :data="certificationsList" ref="certifyingEntitiesTable" stripe search noDataText="No se han generado registros" pagination :max-items="certificationsPerPage">
					<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                            <vs-button color="primary" type="border" icon-pack="feather" @click="openCreateModal('certifications')">Agregar certificación</vs-button>
                        </div>

						<vs-dropdown v-if="isMounted" vs-trigger-click class="cursor-pointer mr-4 items-per-page-handler">
							<div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              					<span class="mr-2">{{ currentCertificationsPage * certificationsPerPage - (certificationsPerPage - 1) }} - {{ certificationsList.length - currentCertificationsPage * certificationsPerPage > 0 ? currentCertificationsPage * certificationsPerPage : certificationsList.length }} de {{ queriedCertificationsItems }}</span>
              					<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            				</div>
            				<vs-dropdown-menu>
              					<vs-dropdown-item v-for="it in itemsPerPageDefinitions" @click="certificationsPerPage = it" :key="it">
                					<span>{{it}}</span>
              					</vs-dropdown-item>
            				</vs-dropdown-menu>	
						</vs-dropdown>
					</div>

					<template slot="thead">
						<vs-th class="bold" sort-key="name">GRUPO DE PRODUCTO</vs-th>
						<vs-th class="bold" sort-key="name">ENTIDAD CERTIFICADORA</vs-th>
						<vs-th class="bold" sort-key="name">CERTIFICACION</vs-th>
						<vs-th class="bold">ACCIONES</vs-th>
					</template>

					<template slot-scope="{data}">
						<vs-tr :key="index" v-for="(tableRow, index) in data">
							
							<vs-td :data="data[index].product_group.name">
								{{ data[index].product_group.name }}
							</vs-td>

							<vs-td :data="data[index].certifying_entity.name">
								{{ data[index].certifying_entity.name }}
							</vs-td>

							<vs-td :data="data[index].name">
								{{ data[index].name }}
							</vs-td>

							<vs-td :data="data[index].id">
								<feather-icon icon="EyeIcon" class="ml-3" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" @click.stop="openEditModal('certification', data[index])" />
								<feather-icon icon="TrashIcon" class="ml-3" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" @click.stop="handleOnDelete('certification', data[index])" />
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vx-card>

            <vs-popup title="Crear entidad certificadora" :active.sync="isCertifyingEntityCreateModalShown" :style="{zIndex: 998}">
                <create-certifying-entity-modal 
					:itemsList="certifyingEntitiesList" 
					v-on:on-save="handleOnSave('certifyingEntity')" />
            </vs-popup>

            <vs-popup title="Editar entidad certificadora" :active.sync="isCertifyingEntityEditModalShown" :style="{zIndex: 998}">
                <edit-certifying-entity-modal 
					ref="editCertifyingEntityModal" 
					:currentItem="currentCertifyingEntity" 
					:itemsList="certifyingEntitiesList" 
					v-on:on-save="handleOnSave('certifyingEntity')" />
            </vs-popup>

			<vs-popup title="Crear certificación" :active.sync="isCertificationsCreateModalShown" :style="{zIndex: 998}">
                <create-certification-modal 
					:itemsList="certificationsList" 
					:productGroupsList="productGroupsList" 
					:certifyingEntitiesList="certifyingEntitiesList" 
					v-on:on-save="handleOnSave('certifications')" />
            </vs-popup>

			<vs-popup title="Editar certificación" :active.sync="isCertificationsEditModalShown" :style="{zIndex: 998}">
                <edit-certification-modal
					ref="editCertificationModal"
					:currentItem="currentCertification"
					:itemsList="certificationsList" 
					:productGroupsList="productGroupsList" 
					:certifyingEntitiesList="certifyingEntitiesList" 
					:logoDocument="logoDocument"
					v-on:on-save="handleOnSave('certifications')" />
            </vs-popup>

        </div>
    </div>
</template>

<script>
import CreateCertificationModal from './CreateCertificationModal.vue';
import CreateCertifyingEntityModal from './CreateCertifyingEntityModal.vue';
import EditCertificationModal from './EditCertificationModal.vue';
import EditCertifyingEntityModal from './EditCertifyingEntityModal.vue';

export default {
	name: "CertificationsCatalog",
    components: {
        CreateCertifyingEntityModal,
        EditCertifyingEntityModal,
        CreateCertificationModal,
        EditCertificationModal
    },
	data() {
		return {
			isMounted: false,

            certifyingEntitiesList: [],
            currentCertifyingEntity: null,
			certifyingEntitiesPerPage: 5,
            isCertifyingEntityEditModalShown: false,
            isCertifyingEntityCreateModalShown: false,

			certificationsList: [],
			currentCertification: null,
			certificationsPerPage: 5,
			isCertificationsEditModalShown: false,
			isCertificationsCreateModalShown: false,

			productGroupsList: [],

			onError: false,
			errorMsg: null,
			itemsPerPageDefinitions: [5, 10, 25, 50],
			logoDocument: null
		}
	},
	async mounted() {
		this.showLoading(true);
		await this.getCertifyingEntitiesList();
		await this.getCertificationsList();
		await this.getProductGroupsList();
		await this.getLogoDocument();
		this.isMounted = true;
		this.showLoading(false);
	},
	computed: {
		currentCertifyingEntitiesPage () {
			if (this.isMounted)
				return this.$refs.certifyingEntitiesTable.currentx;
			return 0;
		},
		queriedCertifyingEntitiesItems () {
			return this.$refs.certifyingEntitiesTable ? this.$refs.certifyingEntitiesTable.queriedResults.length : this.certifyingEntitiesList.length
		},
		currentCertificationsPage () {
			if (this.isMounted)
				return this.$refs.certifyingEntitiesTable.currentx;
			return 0;
		},
		queriedCertificationsItems () {
			return this.$refs.certifyingEntitiesTable ? this.$refs.certifyingEntitiesTable.queriedResults.length : this.certifyingEntitiesList.length
		},
	},
	methods: {
		async getLogoDocument() {
			this.logoDocument = await this.getDocumentById(172);
		},
		async getDocumentById(documentId) {
			try {
				let result = await axios.get(`/api/v1/forms/document/${documentId}`);
				if(result && result.data)
				return result = result.data.document;
			} 
			catch (error) {
				this.warn(error);
				this.onError = true;
			}
		},
		async getCertifyingEntitiesList() {
			try {
				const {data} = await axios.get('/api/v1/certifyingEntities');
				if(data)
					this.certifyingEntitiesList = data;
			} 
			catch (error) {
				this.warn(error);
        		this.failed = true;				
			}
		},
		async getCertificationsList() {
			try {
				const {data} = await axios.get('/api/v1/certifications');
				if(data)
					this.certificationsList = data;
			} 
			catch (error) {
				this.warn(error);
        		this.failed = true;				
			}
		},
		async getProductGroupsList() {
			try {
				const {data} = await axios.get('/api/v1/forms/getProductGroups');
				if(data)
					this.productGroupsList = data;
			} 
			catch (error) {
				this.warn(error);
        		this.failed = true;				
			}
		},
        openEditModal(type, currentItem) {
            switch(type) {
                case 'certifyingEntity': {
                    this.currentCertifyingEntity = currentItem;
                    this.$refs.editCertifyingEntityModal.setValues(currentItem);
                    this.isCertifyingEntityEditModalShown = true;
                    break;
                }
                case 'certification': {
                    this.currentCertification = currentItem;
                    this.$refs.editCertificationModal.setValues(currentItem);
                    this.isCertificationsEditModalShown = true;
                    break;
                }
            }
        },
        openCreateModal(type) {
            switch(type) {
                case 'certifyingEntity': {
                    this.isCertifyingEntityCreateModalShown = true;
                    break;
                }
                case 'certifications': {
                    this.isCertificationsCreateModalShown = true;
                    break;
                }
            }
        },
        async handleOnSave(type) {
            switch(type) {
                case 'certifyingEntity': {
                    await this.getCertifyingEntitiesList();
                    this.isCertifyingEntityCreateModalShown = false;
                    this.isCertifyingEntityEditModalShown = false;
                    break;
                }
                case 'certifications': {
                    await this.getCertificationsList();
                    this.isCertificationsCreateModalShown = false;
                    this.isCertificationsEditModalShown = false;
                    break;
                }
            }
            this.showLoading(false);
        },
        async handleOnDelete(type, item) {
            this.showLoading(true);
            try {
                switch(type) {
                    case 'certifyingEntity': {
                        await axios.put(`api/v1/certifyingEntity/${item.id}/delete`);
                        await this.getCertifyingEntitiesList();
                        break;
                    }
                    case 'certification': {
                        await axios.put(`api/v1/certification/${item.id}/delete`);
                        await this.getCertificationsList();
                        break;
                    }
                }
            } 
            catch (error) {
                console.log(error);
                this.warn(error);
        		this.failed = true;	
            }
            this.showLoading(false);
        }
	}
}
</script>